module.exports = __webpack_public_path__ + "img/Carno_Thumb.1869fc9c.jpg";